import React from "react";

import { BlockDetailsCard, Header } from "../../components";
import { IFlexOneCard } from "../../interfaces";

const FlexOneCard: React.FC<IFlexOneCard> = (props: IFlexOneCard) => {
  const {
    headerInfo: { heading, subHeading },
    cardInfo,
  } = props;

  return (
    <>
      <Header heading={heading} subHeading={subHeading} />
      <BlockDetailsCard {...cardInfo} />
    </>
  );
};

export default FlexOneCard;
